import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import noop from 'lodash/noop';
import debounce from 'lodash/debounce';
import UserInterfaceConfig from '@Services/UserInterfaceConfig';
import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import * as WindowHelper from '@Services/WindowHelper';
import Accordion from '@Pages/ProfileSettings/Preferences/components/Accordion';
import ProfileSettingsAccordionItem from '@Pages/ProfileSettings/Components/ProfileSettingsAccordionItem';

import './TextSize.theme.scss';

function TextSize({ currentOption, options, onChange, onSave, onClose }) {
  const [fontSizeFixed, setFontSizeFixed] = useState(null);

  useEffect(() => {
    const resizeHandler = () => {
      const fontSize = UserInterfaceConfig.isFixedFontSize();
      setFontSizeFixed(fontSize);
    };

    const offResize = WindowHelper.onResize(debounce(resizeHandler, 300));
    return () => {
      offResize();
    };
  }, []);

  if (fontSizeFixed) {
    return (
      <Accordion
        open={false}
        className="text-size-accordion-item"
        heading={
          <div className="rx-accordion-row profile-settings-accordion-row disabled">
            <span className="profile-settings-accordion-row_label">{ProfileSettingsConfig.Labels.textSize}</span>
            <span className="profile-settings-accordion-row_value" title={ProfileSettingsConfig.Labels.textSize}>
              <span className={`text-size-preview text-size-preview-${currentOption * 100}`} />
            </span>
          </div>
        }
      />
    );
  }

  return (
    <ProfileSettingsAccordionItem
      onClose={onClose}
      onSave={onSave}
      label={ProfileSettingsConfig.Labels.textSize}
      value={<span className={`text-size-preview text-size-preview-${currentOption * 100}`} />}
      title={ProfileSettingsConfig.Labels.textSize}
      titled
      notTagged
      validateOnSave
      className="text-size-accordion-item">
      <div className="text-size-accordion-item__wrapper">
        {options.map((option) => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
          <span
            key={`text-size-${option.value}`}
            className={cn(`preferences-text-value text-size-${option.value * 100}`, currentOption === option.value && 'active')}
            onClick={() => onChange('RX2_PAGE_STYLE_TEXT_SIZE_RELATIVE', option.value)}
          />
        ))}
      </div>
    </ProfileSettingsAccordionItem>
  );
}

TextSize.propTypes = {
  currentOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.array,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

TextSize.defaultProps = {
  options: [],
  onChange: noop,
  onSave: noop,
  onClose: noop,
};

export default TextSize;
